import { createFileRoute } from "@tanstack/react-router";
import { SeoContentPage } from "@/components/SeoContentPage";
import { aiSysteemHusselToss } from "@/pages/seo-content";

const title = "AI systeem voor hussel en toss indelingen | De Hussel App";
const description = "Slim AI systeem voor hussel en toss: automatische indelingen op niveau, speeltijd en variatie voor tennis- en padelclubs.";

export const Route = createFileRoute("/ai-systeem-hussel-toss")({
  head: () => ({
    meta: [
      { title },
      { name: "description", content: description },
      { property: "og:title", content: title },
      { property: "og:description", content: description },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://dehusselapp.nl/ai-systeem-hussel-toss" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: "https://dehusselapp.nl/ai-systeem-hussel-toss" }],
  }),
  component: () => <SeoContentPage data={aiSysteemHusselToss} />,
});
